import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');

const formatLbgj = (flag, dt) => {
  if (moment(flag).format('YYYYMMDD') === moment(dt).format('YYYYMMDD')) {
    return moment(dt).format('HH:mm');
  }
  if (moment(flag).format('YYYY') === moment(dt).format('YYYY')) {
    return moment(dt).format('MM-DD');
  }
  return moment(dt).format('YYYY-MM-DD');
};

const formatChn = dt => moment(dt).format('YYYY年M月D日');

const formatStd = dt => moment(dt).format('YYYY年MM月DD日');

export { formatLbgj, formatChn, formatStd };
